<div class="content-container mx-auto my-4">
    <h1 class="mt-0">Host confirmation</h1>

    @if (loading) {
        <ngxh6-loading-or-error></ngxh6-loading-or-error>
    } @else if (notFound) {
        <div class="alert alert-warning" role="alert">This confirmation link is invalid or has expired. Please contact the Tiwi Land Council office.</div>
    } @else if (confirmed) {
        <div class="alert alert-success" role="alert">
            <h4 class="mt-0">Thank you</h4>
            <p class="mb-0">
                You've confirmed you are hosting <strong>{{ details?.applicantName }}</strong
                >. The Tiwi Land Council will now review the application.
            </p>
        </div>
    } @else {
        <p>
            <strong>{{ details?.applicantName }}</strong> has applied for a <strong>{{ details?.permitType }}</strong> and named you as their host.
        </p>
        <p>Do you accept responsibility for hosting this visitor?</p>

        @if (error) {
            <div class="alert alert-danger text-break" role="alert">{{ error }}</div>
        }

        <button type="button" class="btn btn-primary ms-0" (click)="confirm()" [disabled]="submitting">Yes, I confirm I am hosting this visitor</button>
    }
</div>
